/**
 * np-slide-swap.js — left/right slide used to switch content in place
 * ("You may also like" dots, collection pagination, Stockists region pills)
 *
 * npSlideSwap(viewport, el, forward, update)
 *   viewport: .np-slide-viewport (position: relative; overflow: hidden)
 *   el:       the element inside it that is swapped
 *   forward:  true slides to the left (next), false to the right (previous)
 *   update:   function that changes el's content
 * A snapshot of the old content slides out while the new one slides in.
 * Without animation support or with prefers-reduced-motion, it just updates.
 * Returns false while a previous swap is still running.
 */

(function () {
  function duration() {
    // same speed as the product image slider
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--slide-duration'));
    return (v || 0.65) * 1000;
  }

  window.npSlideSwap = function (viewport, el, forward, update) {
    if (viewport.dataset.npSliding) return false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !el.animate) {
      update();
      return true;
    }

    viewport.dataset.npSliding = '1';
    var old = el.cloneNode(true);
    old.removeAttribute('id');
    old.classList.add('np-slide-outgoing');
    old.setAttribute('aria-hidden', 'true');
    viewport.appendChild(old);

    update();

    var opts = { duration: duration(), easing: 'ease' };
    var out = forward ? '-100%' : '100%';
    var inFrom = forward ? '100%' : '-100%';
    old.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + out + ')' }], opts);
    var anim = el.animate([{ transform: 'translateX(' + inFrom + ')' }, { transform: 'translateX(0)' }], opts);
    anim.onfinish = anim.oncancel = function () {
      old.remove();
      delete viewport.dataset.npSliding;
    };
    return true;
  };
})();
